import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "sig-guide" }
const _hoisted_3 = { class: "signature-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_signature_pad = _resolveComponent("signature-pad")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_signature_pad, {
      modelValue: _ctx.signatureDataURL,
      onInput: _ctx.onInput,
      width: 500,
      height: 300,
      customStyle: _ctx.customStyle,
      saveType: _ctx.saveType,
      saveOutput: _ctx.saveOutput,
      ref: "signaturePad"
    }, null, 8, ["modelValue", "onInput", "customStyle", "saveType", "saveOutput"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createVNode(_component_font_awesome_icon, {
          size: "lg",
          icon: "mouse-pointer"
        }),
        _cache[0] || (_cache[0] = _createTextVNode("   ", -1)),
        _createVNode(_component_TranslatedText, { path: "signature.guide" })
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", null, [
      _createElementVNode("p", null, [
        _createVNode(_component_TranslatedText, { path: "declaration.main" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "footer", {
        confirm: _ctx.handleConfirm,
        cancel: _ctx.handleCancel,
        clear: _ctx.clearSignature
      }, () => [
        _createVNode(_component_Button, {
          class: "left",
          text: "common.cancel",
          size: "sm",
          variant: "secondary",
          onClick: _ctx.handleCancel
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          text: "common.clear-signature",
          size: "sm",
          disabled: _ctx.model.signature.length === 0,
          onClick: _ctx.clearSignature,
          variant: "secondary"
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          text: "Save Signature",
          size: "sm",
          disabled: !_ctx.model.signature.length > 0,
          onClick: _ctx.handleConfirm
        }, null, 8, ["disabled", "onClick"])
      ], true)
    ])
  ]))
}